

<template>
  <v-dialog :value="literaturaAlert"
            @input="$emit('update:literaturaAlert', $event)"
            :fullscreen="$vuetify.breakpoint.smAndDown"
            max-width="500">
    <v-card max-width="500">
      <v-card-title class="font-rubik">⚠️ Atenció!</v-card-title>
      <v-divider></v-divider>
      <div class="pa-5">
          <span class="font-rubik">Acabes d'afegir LITERATURA {{ literaturaAlertMsg }} (optativa) que és diferent de LLENGUA {{
              literaturaAlertMsg
            }} (comuna). </span>
      </div>

      <div class="d-flex flex-column align-center py-5">
        <v-btn
          @click="swapCart(literaturaAlertMsg=='CASTELLANA' ? 29 : 30, literaturaAlertMsg=='CASTELLANA' ? 10 : 9)"
          color="primary" class="mb-3 font-rubik">Canviar i comprar LLENGUA {{ literaturaAlertMsg }}
        </v-btn>
        <v-btn
          @click="$emit('update:literaturaAlert', false)"
          class="font-rubik">Comprar LITERATURA {{ literaturaAlertMsg }}
        </v-btn>
      </div>
    </v-card>
  </v-dialog>

</template>

<script>
import {getCart, setCart} from "../cart/cart";

export default {
  name: "AlertaLiteratura",
  props: {
    literaturaAlert: Boolean,
    literaturaAlertMsg: String,
    books: Array
  },
  data() {
    return {}
  },
  methods: {
    // Canvia la unitat de literatura que acaben d'afegir per la de llengua, directament a la galeta
    // (abans buscava el llibre amb `b.book_id = newId`, que canviava l'id del primer llibre de la llista)
    swapCart(oldId, newId) {
      const list = getCart(this)
      if (list[oldId] > 1) list[oldId]--
      else delete list[oldId]
      list[newId] = (list[newId] || 0) + 1
      setCart(this, list)
      this.$funnel.track('add_to_cart', {placement: 'literatura_swap', book_id: newId})
      this.$emit("update:literaturaAlert", false)
    },
  }
}
</script>

<style scoped>

</style>
